// Client-side image resize + compression with EXIF orientation handling.
// Returns a JPEG File suitable for avatar/card use. Throws "HEIC" or "DECODE" on failure.
export async function processImage(file, { maxSize = 1000, quality = 0.82 } = {}) {
  const isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || "");
  let bitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch {
    try {
      bitmap = await createImageBitmap(file);
    } catch {
      throw new Error(isHeic ? "HEIC" : "DECODE");
    }
  }
  let { width, height } = bitmap;
  const scale = Math.min(1, maxSize / Math.max(width, height));
  width = Math.max(1, Math.round(width * scale));
  height = Math.max(1, Math.round(height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0, width, height);
  if (bitmap.close) bitmap.close();
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
  if (!blob) throw new Error("ENCODE");
  return new File([blob], "photo.jpg", { type: "image/jpeg" });
}
